import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideCalendarX = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M8 2v4m8-4v4" />
      <rect width={18} height={18} x={3} y={4} rx={2} />
      <path d="M3 10h18m-7 4-4 4m0-4 4 4" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideCalendarX);
const Memo = memo(ForwardRef);
export default Memo;
